import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-user-info-dialog',
  templateUrl: './user-info-dialog.component.html',
  styleUrls: ['./user-info-dialog.component.scss']
})
export class UserInfoDialogComponent implements OnInit {

  user: any = null;

  constructor(
    private baseService: BaseService,
    private dialogRef: MatDialogRef<UserInfoDialogComponent>
  ) { }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_pos_store_user_info', {test: 1})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.user = response.data;
        } else {
          this.dialogRef.close();
        }
      });
  }

}
